var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
// @ts-ignore
import { Provider, ThemeProvider } from 'react-fela';
import createRenderer from './create-renderer';
import defaultTheme from './default-theme';
var FixedProvider = Provider;
var FilouProvider = function (_a) {
    var theme = _a.theme, children = _a.children, _b = _a.renderer, renderer = _b === void 0 ? createRenderer({}) : _b, _c = _a.rehydrate, rehydrate = _c === void 0 ? true : _c;
    var props = {};
    if (typeof document !== 'undefined') {
        var element = document.getElementById('stylesheet');
        if (element) {
            document.body.removeChild(element);
        }
        element = document.createElement('style');
        element.id = 'stylesheet';
        document.body.appendChild(element);
        var stylesheet = document.getElementById('stylesheet');
        props['mountNode'] = stylesheet;
    }
    return (React.createElement(FixedProvider, __assign({ renderer: renderer, rehydrate: rehydrate }, props),
        React.createElement(ThemeProvider, { theme: defaultTheme(theme) }, children)));
};
export default FilouProvider;
//# sourceMappingURL=provider.js.map